import { CommonModule, DatePipe } from "@angular/common";
import { Component, computed, effect, EventEmitter, inject, input, OnChanges, Output } from "@angular/core";
import { EvCore } from "ev-core";
import { SaleInArea } from "src/models/estate/IResidenceSaleInArea";
import { EstateSaleItemHoverService } from "src/services/estate/estate-sale-item-hover.service";
import { FavoriteListDataService } from "src/services/estate/favorite-list-data.service";
import { MarketSalesDataService } from "src/services/estate/market-sales-data.service";
import { MapStateService } from "src/services/map/map-state.service";
import { SelectedFavoriteListsStore } from "src/stores/selected-favorite-list.store";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";

@Component({
    selector: "estate-sale-item",
    imports: [CommonModule, EvCore, DatePipe],
    templateUrl: "./estate-sale-item.component.html",
    styleUrl: "./estate-sale-item.component.scss",
})
export class EstateSaleItemComponent implements OnChanges {
    sale = input.required<SaleInArea>();
    includeCommonDebt = input<boolean>(false);
    @Output() estateClicked: EventEmitter<void> = new EventEmitter<void>();
    hovered: boolean;
    authService: EvAuthorizationService = inject(EvAuthorizationService);
    shouldShowCartIcon: boolean = false;
    estateListEditMode: boolean = false;
    private isHousingCooperative: boolean = false;
    private readonly marketSalesDataService: MarketSalesDataService = inject(MarketSalesDataService);
    private readonly estateSaleItemHoverService = inject(EstateSaleItemHoverService);
    readonly selectedFavoriteListStore = inject(SelectedFavoriteListsStore);
    readonly favoriteListDataService = inject(FavoriteListDataService);
    readonly mapStateService = inject(MapStateService);

    inCart = computed(() => this.selectedFavoriteListStore.units().includes(this.sale().unitId));

    constructor() {
        this.mapStateService.estateListEditMode$.subscribe(mode => {
            this.estateListEditMode = mode;
        })
        effect(() => {
            if (this.estateSaleItemHoverService.estateSaleItemHoverSignal()) {
                this.hovered = this.estateSaleItemHoverService.isHoverdBasedOnUnitId(this.sale());
            }
        });
    }

    ngOnChanges() {
        if (this.sale() != null && (this.sale().sortDateAsString == null || this.sale().sortDateAsString === "")) {
            this.sale().sortDate = null;
        }
        if (this.sale() != null) {
            this.isHousingCooperative = this.sale().ownershipType === "Borettslag" && this.sale().shareNumber == null;
            this.sale().estateType = this.isHousingCooperative ? "Borettslag" : this.sale().estateType;
            this.shouldShowCartIcon = this.showCartIcon(this.sale());
        }
    }

    selectSale(sale: SaleInArea): void {
        this.marketSalesDataService.setSale(sale);
        this.estateClicked.emit();
    }

    modifyCart(e: MouseEvent) {
        e.stopPropagation();
        if (this.inCart()) {
            this.favoriteListDataService.removeUnit(this.sale().unitId);
        } else {
            this.favoriteListDataService.addUnit(this.sale().unitId, this.sale());
        }
    }

    onMouseEnter() {
        this.estateSaleItemHoverService.setHover([this.sale()]);
    }

    onMouseLeave() {
        this.estateSaleItemHoverService.setHover([]);
    }

    private showCartIcon(item: SaleInArea): boolean {
        if (this.isHousingCooperative || item.ownershipType === "Obl_leilighet" || item.ownershipType === "Aksjeleilighet") {
            return false;
        }
        return true;
    }
}
